import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ModalForm } from '../../components';
import {
    Text,
    Message,
    Card,
    Image,
    OutIcon,
    ButtonGroup,
    DaButton,
    CheckIcon,
    InternalGrid,
    Box,
} from '@paygreen/paygreen-ui';
import { updateOdd } from './service';
import { DaButtonStyled } from './Project.styled';
import { useAPIError, useUser } from '../../context';
import updateMainSDG from '../../utils/getMainSdg';

const OddModal = ({
    isOpen,
    goals,
    name,
    idProject,
    selectedSDG,
    onClick,
    fetchData,
}) => {
    const { t } = useTranslation();
    const { addError } = useAPIError();

    const getMainSDG = JSON.parse(localStorage.getItem('mainSDG'));

    const { user } = useUser();

    const renderMessageContent = () => {
        return t(`contributions.globalView.modalCard.messages`).map(
            (element, index) => (
                <Text
                    key={index}
                    colorPallet="theme"
                    colorTheme="secondary"
                    textSize="xxs"
                >
                    {element}
                </Text>
            ),
        );
    };

    const handleChoiceOdd = async (id) => {
        try {
            await updateOdd(idProject, id);

            updateMainSDG(user?.idUser?.toString());
        } catch (error) {
            addError(
                error?.response?.data.detail,
                error?.response?.data.status,
            );
        }

        fetchData();
        onClick();
    };

    const shouldUpdatOdd = (goal) => {
        if (goal.id !== selectedSDG && isMainOdd(goal)) {
            handleChoiceOdd(goal.id);
        }
    };

    const isMainOdd = (goal) => {
        if (getMainSDG) {
            return getMainSDG[goal?.id] !== goal.id;
        }

        return false;
    };

    const isProjectHasMainOdd = (goal) => {
        if (getMainSDG) {
            return getMainSDG[goal.id] === goal.id;
        }

        return false;
    };

    const isButtonActionDisabled = (goal) => {
        if (getMainSDG) {
            return goal.id === selectedSDG || getMainSDG[goal.id] === goal.id;
        }

        return false;
    };

    const isOddAlreadySet = (goal) => {
        if (getMainSDG) {
            return getMainSDG[goal?.id] === goal?.id && selectedSDG !== goal.id;
        }

        return false;
    };

    const renderOddCard = () => {
        return goals?.map((goal) => {
            return (
                <Card key={goal.id}>
                    <InternalGrid alignItems="center">
                        <Box>
                            <Image
                                blockHeight="tiny"
                                blockWidth="tiny"
                                style={{ width: '80px', height: '80px' }}
                                className="gray-filter"
                                imageType="cover"
                                marginLeft="sm"
                            >
                                <img src={goal.iconUri} alt="project view" />
                            </Image>
                        </Box>

                        <Box marginLeft="xs" marginRight="xs">
                            <ButtonGroup marginBottom="xs" marginTop="xs">
                                <InternalGrid
                                    style={{
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Box marginBottom="xs">
                                        <button
                                            disabled={isButtonActionDisabled(
                                                goal,
                                            )}
                                            type="button"
                                        >
                                            <DaButtonStyled
                                                isDisabled={isOddAlreadySet(
                                                    goal,
                                                )}
                                                title={
                                                    isOddAlreadySet(goal)
                                                        ? t(
                                                              'contributions.globalView.globalCard.isAlreadyMainSDG',
                                                          )
                                                        : null
                                                }
                                                userProjects={isMainOdd(goal)}
                                                onClick={() => {
                                                    shouldUpdatOdd(goal);
                                                }}
                                                gradient={
                                                    isOddAlreadySet(goal)
                                                        ? 'brand'
                                                        : 'theme'
                                                }
                                                buttonSize="sm"
                                                colorPallet="theme"
                                                colorTheme="primary"
                                                colorType={
                                                    goal.id === selectedSDG &&
                                                    isProjectHasMainOdd(goal)
                                                        ? 'reverse'
                                                        : 'original'
                                                }
                                                icon={<CheckIcon />}
                                            >
                                                {t(
                                                    'contributions.globalView.modalCard.principalOdd',
                                                )}
                                            </DaButtonStyled>
                                        </button>
                                    </Box>

                                    <Box marginBottom="xs">
                                        <a
                                            href={goal.docUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <DaButton
                                                buttonSize="sm"
                                                buttonStyle="line"
                                                colorPallet="theme"
                                                colorTheme="secondary"
                                                icon={<OutIcon />}
                                            >
                                                {t(
                                                    'contributions.globalView.globalCard.moreInfo',
                                                )}
                                            </DaButton>
                                        </a>
                                    </Box>
                                </InternalGrid>
                            </ButtonGroup>
                        </Box>
                    </InternalGrid>
                </Card>
            );
        });
    };

    return (
        <ModalForm
            hasCloseCross
            paddingBottom="xs"
            blockWidth="md"
            textSize="md"
            modalTitle={t('contributions.globalView.modalCard.title')}
            isOpen={isOpen}
        >
            <Text
                colorPallet="wab"
                textSize="sm"
                marginBottom="xs"
                colorWab="grey50"
            >
                <Trans
                    i18nKey="contributions.globalView.modalCard.description"
                    values={{ project: name }}
                    components={{ bold: <strong /> }}
                />
            </Text>

            <InternalGrid childrenMarginBottom="md">
                {renderOddCard()}
            </InternalGrid>

            <Message marginTop="md" hasStaticWidth>
                <InternalGrid
                    childrenMarginBottom="sm"
                    style={{ flexDirection: 'column' }}
                >
                    {renderMessageContent()}
                </InternalGrid>
            </Message>
        </ModalForm>
    );
};

export default OddModal;
